import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import GlobalHeader from "../components/GlobalHeader.js";

import "./PageWrapper.css";

const PageWrapper = ({ children, dispatch, history, game }) => {

  return (
    <div className="page-wrapper">
      <GlobalHeader />
      <div className="page-container">
        {React.cloneElement(children, {})}
      </div>
    </div>
  );
};

export default connect(({
  phone
}) => ({
  phone
}))(PageWrapper);
